














import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class DetailBox extends Vue {
  @Prop({ default: false }) private spinning!: boolean;
  @Prop({ default: false }) private isEmpty!: boolean;
}
